import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ng_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Extract a user-friendly string from an axios error. Handles:
//  - string detail (FastAPI HTTPException)
//  - array of validation errors (Pydantic 422)
//  - object detail
//  - network / no-response errors
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => (x && (x.msg || x.type)) || "").filter(Boolean).join(" · ") || fallback;
  }
  if (typeof d === "object") return d.msg || d.error || fallback;
  return String(d);
}
